import React from 'react';
import './Homepage.css';

const Homepage = ({ onSignInClick }) => {
  return (
    <div className="homepage">
      <div className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Your Personal Recipe Collection
            </h1>
            <p className="hero-subtitle">
              Store, organize, and access your favorite recipes without the clutter. 
              No ads, no endless scrolling, no life stories - just your recipes, simplified.
            </p>
            <div className="hero-features">
              <div className="feature">
                <span className="feature-icon">📝</span>
                <span>Quick Recipe Entry</span>
              </div>
              <div className="feature">
                <span className="feature-icon">🔗</span>
                <span>URL Scraping</span>
              </div>
              <div className="feature">
                <span className="feature-icon">📱</span>
                <span>Mobile Friendly</span>
              </div>
              <div className="feature">
                <span className="feature-icon">🚫</span>
                <span>No Ads Ever</span>
              </div>
            </div>
            <button className="cta-button" onClick={onSignInClick}>
              Start Organizing Your Recipes
            </button>
          </div>
        </div>
      </div>

      <div className="benefits-section">
        <div className="container">
          <h2 className="section-title">Why Choose Dinner Haus?</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <h3>No More Recipe Blogs</h3>
              <p>
                Skip the endless paragraphs about childhood memories and get straight to the recipe. 
                Store only what matters: ingredients and instructions.
              </p>
            </div>
            <div className="benefit-card">
              <h3>Your Recipes, Your Way</h3>
              <p>
                Import from any website, add your own notes, and organize everything exactly 
                how you want it. No algorithm deciding what you see.
              </p>
            </div>
            <div className="benefit-card">
              <h3>Always Accessible</h3>
              <p>
                Access your recipes from any device, anywhere. Perfect for grocery shopping 
                or cooking in the kitchen.
              </p>
            </div>
            <div className="benefit-card">
              <h3>Privacy First</h3>
              <p>
                Your recipes are private by default. No sharing unless you want to. 
                No tracking, no data selling, no nonsense.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="features-section">
        <div className="container">
          <h2 className="section-title">Features That Actually Matter</h2>
          <div className="features-list">
            <div className="feature-item">
              <div className="feature-icon-large">🌐</div>
              <div className="feature-content">
                <h3>Smart Recipe Import</h3>
                <p>Paste any recipe URL and we'll extract just the important parts - no fluff, no ads, no life stories.</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon-large">📋</div>
              <div className="feature-content">
                <h3>Clean Interface</h3>
                <p>See your ingredients and instructions clearly. No distractions, no pop-ups, just your recipe.</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon-large">🔍</div>
              <div className="feature-content">
                <h3>Quick Search</h3>
                <p>Find any recipe instantly by name, ingredient, or tag. No more scrolling through endless lists.</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon-large">📱</div>
              <div className="feature-content">
                <h3>Mobile Optimized</h3>
                <p>Perfect for use in the kitchen. Large text, simple navigation, works on any device.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Simplify Your Recipe Collection?</h2>
            <p>Join thousands of home cooks who've ditched recipe blogs for good.</p>
            <button className="cta-button" onClick={onSignInClick}>
              Get Started Free
            </button>
            <p className="cta-note">No credit card required. Start organizing immediately.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homepage;